import React from 'react';
import { Line } from 'react-chartjs-2';
import 'chart.js/auto';

const ExtendedStockChart = ({ stock, onClose }) => {
  const limitedPrices = stock.prices.slice(-50);
  const flatPrices = limitedPrices.map(price => price.price);

  const data = {
    labels: limitedPrices.map((price, index) => `Time ${index + 1}`),
    datasets: [
      {
        label: `${stock.symbol} Price`,
        data: flatPrices,
        fill: true,
        borderColor: '#4bc0c0',
        backgroundColor: 'rgba(75, 192, 192, 0.2)',
        pointRadius: 3,
        borderWidth: 2,
        tension: 0.4,
      },
    ],
  };

  const options = {
    scales: {
      x: {
        display: false,
      },
      y: {
        display: true,
        title: {
          display: true,
          text: 'Price (💴)',
          color: '#fff',
          font: {
            size: 14,
          },
        },
        grid: {
          color: 'rgba(255, 255, 255, 0.1)',
        },
        ticks: {
          color: '#fff',
          stepSize: 1,
        },
      },
    },
    plugins: {
      legend: {
        display: true,
        labels: {
          color: '#fff',
          font: {
            size: 14,
          },
        },
      },
      tooltip: {
        callbacks: {
          label: (context) => `💴 ${context.raw.toFixed(2)}`,
        },
      },
    },
    responsive: true,
    maintainAspectRatio: false,
  };

  return (
    <div className="modal">
      <div className="modal-content">
        <span className="close" onClick={onClose}>&times;</span>
        <div className="stock-chart" style={{ position: 'relative', height: '20rem', width: '100%' }}>
          <Line data={data} options={options} />
        </div>
      </div>
    </div>
  );
};

export default ExtendedStockChart;
